module.exports = __webpack_public_path__ + "img/view-cloud.96581464.png";